import { useMemo } from "react";

export const useCustomError = (error?: boolean, errorMessage?: React.ReactNode | string): boolean =>
  useMemo(() => error || Boolean(errorMessage), [error, errorMessage]);
